export default "__VITE_ASSET__DLzSRfl1__"